// extracted by mini-css-extract-plugin
export default {"root":"EditAlbum_root__HpK3T","image":"EditAlbum_image__kWGof"};